import { AxiosError, isAxiosError } from 'axios';
import Personnummer from 'personnummer';
import { z } from 'zod';

export const msg = {
  required: 'Detta fält är obligatoriskt',
  email: 'Ange en giltig e-postadress',
  phone: 'Ange ett telefonnummer inkl. landsnummer',
  date: 'Ange ett datum i formatet YYYY-MM-DD',
  ssn: 'Ange ett giltigt personnummer i formatet YYMMDDXXXX',
  passwordConfirm: 'Dem två olika lösenorden matchar inte',
  passwordMin: 'Ditt lösenord behöver vara minst 8 tecken långt',
  website: 'Måste börja med http eller https',
  username: 'Användarnamnet innehåller otillåtna tecken',
  usernameMin: 'Användarnamnet måste vara minst 2 tecken långt',
  usernameMax: 'Användarnamnet kan inte vara längre än 50 tecken',
};

export const emailSchema = z.string().email({ message: msg.email });
export const optionalEmailSchema = z.union([z.literal(''), emailSchema]);

export const phoneSchema = z.string().regex(/^\+46\d{9}$/, { message: msg.phone });
export const optionalPhoneSchema = z.union([z.literal(''), phoneSchema]);

export const passwordSchema = z.string().min(8, { message: msg.passwordMin });
export const usernameSchema = z
  .string()
  .min(2, { message: msg.usernameMin })
  .max(50, { message: msg.usernameMax })
  .regex(/^[a-zA-Z0-9åäöÅÄÖ_@+.-]+$/, { message: msg.username });

export const personalIdentityNumberSchema = z
  .string({ message: msg.required })
  .refine(value => Personnummer.valid(value), {
    message: msg.ssn,
  })
  .transform(value => value.replace('-', ''))
  .transform(value => (value.length === 12 ? value.substring(2) : value));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidationError<T = any, D = any>(
  payload: unknown
): payload is AxiosError<Record<keyof T, string[]>, D> {
  return isAxiosError(payload) && payload.status === 400;
}
